import React from "react";

// Scss imports
import css from "./SelectElement.module.scss";

interface SelectElementProps {
  label: string;
  id: string;
  name: string;
  handleChange?: any;
  title?: boolean;
  rowFormGroup?: boolean;
  minLabelWidth?: boolean;
  selectOptionsArray?: any;
  errorTextColumn?: string;
  type?: string;
}

const SelectElement: React.FC<SelectElementProps> = ({
  label,
  id,
  name,
  handleChange,
  selectOptionsArray,
  rowFormGroup,
  minLabelWidth,
  errorTextColumn,
  type
}) => {
  return (
    <div
      className={`${css.formGroup} ${rowFormGroup ? css.rowFormGroup : null} ${
        type === "filterSelect" ? css.filterDiv : ""
      }`}
    >
      <label
        className={`${minLabelWidth ? css.minLabelWidth : ""} ${
          rowFormGroup ? css.rowLabel : null
        }`}
        htmlFor={id}
      >
        {label}
      </label>
      <div className={css.selectError}>
        <select
          className={`${errorTextColumn ? css.errorSelect : ""} ${
            type === "filterSelect" ? css.filterSelect : ""
          } ${type === "marginTopSelect" ? css.marginTop : ""}`}
          id={id}
          name={name}
          onChange={handleChange}
        >
          {selectOptionsArray.map((selectOption) => {
            return (
              <option key={selectOption.value} value={selectOption.value}>
                {selectOption.name}
              </option>
            );
          })}
        </select>
        {errorTextColumn !== "" && (
          <p className={css.errorText}>{errorTextColumn}</p>
        )}
      </div>
    </div>
  );
};

export default SelectElement;
